import { Component, OnInit } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions } from '@covalent/core';
import { BranchService } from '../branch.service';
import { LocationService } from 'services/location.service';
import { TdLoadingService } from '@covalent/core';
import { TdDialogService } from '@covalent/core';

import { Branch } from '../../branch';
import { Company } from '../../company';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { CurrencyService } from '../../../../shared/services/currency.service';

@Component({
  selector: 'app-branches-save',
  templateUrl: './branches-save.component.html',
  styleUrls: ['./branches-save.component.scss'],
  providers: [CurrencyService]
})
export class BranchesSaveComponent implements OnInit {
  data: Branch;
  currentBranch: Branch;

  originalBranch: Branch;

  currentBranches: Branch[] = [];
  subscription: Subscription = new Subscription();
  allCity: any[];
  branchItem: Branch;
  title: string;
  isEditMode: boolean;

  _currencies: any[];

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _branchService: BranchService,
    private _locationService: LocationService,
    public _authService: AuthenticationService,
    private _currencyService: CurrencyService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap
      .switchMap(
        (params: ParamMap) => this.mode(params.get('id'))
      )
      .subscribe((currentBranch: Branch) => {
        this.currentBranch = currentBranch;
        // Set up the reference branch
        this.originalBranch = Object.assign({}, this.currentBranch);

        this._loadingService.resolve('loading');
      });

    this._locationService.getCity()
      .subscribe((cities: any[]) => {
        this.allCity = cities.map(city => {
          city.id = Number(city.id);
          return city;
        });
      });
  }

  changed(): boolean {
    for (let prop in this.currentBranch) {
      if (this.currentBranch[prop] != this.originalBranch[prop]) {
        return true;
      }
    }

    return false;
  }

  filterCurrencies($event) {
    this._currencies = this._currencyService.getAllCurrencies().filter(
      c => {
        return (c.code.toLowerCase().indexOf($event.toLowerCase()) >= 0 || c.description.toLowerCase().indexOf($event.toLowerCase()) >= 0);
      }
    )
  }

  goBack(): void {
    this.location.back();
  }

  canUpdate() {
    return this._authService.getUserBranches().some((b: Branch) => { return b.id == this.currentBranch.id });
  }

  save(isEditMode: boolean): void {
    if (!this.currentBranch.code) {
      this._dialogService.openAlert({
        message: 'Code field is required',
        title: 'Error',
      });
      return;
    }

    this._loadingService.register('loading');

    this.currentBranch.name = this.currentBranch.name ? this.currentBranch.name : '';
    this.currentBranch.code = this.currentBranch.code ? this.currentBranch.code : '';
    this.currentBranch.contact_name = this.currentBranch.contact_name ? this.currentBranch.contact_name : '';
    this.currentBranch.address = this.currentBranch.address ? this.currentBranch.address : '';
    this.currentBranch.contact_address = this.currentBranch.contact_address ? this.currentBranch.contact_address : '';
    this.currentBranch.city_id = this.currentBranch.city_id ? Number(this.currentBranch.city_id) : 1;
    this.currentBranch.contact_city_id = this.currentBranch.contact_city_id ? Number(this.currentBranch.contact_city_id) : 1;
    this.currentBranch.contact_phone = this.currentBranch.contact_phone ? this.currentBranch.contact_phone : '';
    this.currentBranch.contact_mobile = this.currentBranch.contact_mobile ? this.currentBranch.contact_mobile : '';
    this.currentBranch.contact_fax = this.currentBranch.contact_fax ? this.currentBranch.contact_fax : '';
    this.currentBranch.contact_email = this.currentBranch.contact_email ? this.currentBranch.contact_email : '';
    this.currentBranch.invoice_starting_num = this.currentBranch.invoice_starting_num ? Number(this.currentBranch.invoice_starting_num) : 0;
    this.currentBranch.currency_exchange_rate_euro = this.currentBranch.currency_exchange_rate_euro ? Number(this.currentBranch.currency_exchange_rate_euro) : 1;
    this.currentBranch.invoice_series = this.currentBranch.invoice_series ? this.currentBranch.invoice_series : '';
    this.currentBranch.sales_tax = this.currentBranch.sales_tax ? Number(this.currentBranch.sales_tax) : 0;
    this.currentBranch.sales_tax2 = this.currentBranch.sales_tax2 ? Number(this.currentBranch.sales_tax2) : 0;
    this.currentBranch.company_id = this.currentBranch.company_id ? Number(this.currentBranch.company_id) : 1;
    this.currentBranch.currency_id = 1;

    this._branchService.saveBranch(this.currentBranch)
      .subscribe((response: any) => {
        if (response.status == 'SUCCESS') {
          let name = this.currentBranch.name || '';
          this._loadingService.resolve('loading');

          // Set up the reference branch again
          this.originalBranch = Object.assign({}, this.currentBranch);

          this._dialogService.openAlert({
            message: 'Successfully '
              + (this.isEditMode ? 'saved' : 'added')
              + ' ' + name + '!',
            title: 'Success',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/accounting', 'branches']);
            /*if (!this.isEditMode) {
              this.currentBranch = new Branch();
            }*/
          });
        }
      },
        error => {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({ title: 'Error', message: 'An error occurred' });
        }
      );
  }

  mode(id: string): Observable<Branch> {
    if (id) {
      this.title = 'Edit Branch';
      this.isEditMode = true;
      return this._branchService.getBranch(parseInt(id));
    }

    this.title = 'Create Branch';
    this.isEditMode = false;
    return Observable.of(new Branch());
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/branches/branches-save/branches-save.component.ts